/**
 *
 * CampaignTemplates/Show/Disclaimer
 *
 */

import React from 'react'

// NPM Libraries
import Parser from 'html-react-parser'
import PropTypes from 'prop-types'
import { convertFromRaw } from 'draft-js'
import { stateToHTML } from 'draft-js-export-html'

// Utils
import { sanitizeDraftJsMap } from 'components/utils'

function Disclaimer({ advisor: { landing_page_disclaimers_json } }) {
	return landing_page_disclaimers_json ? (
		<React.Fragment>
			{landing_page_disclaimers_json.map((disclaimer_json) => (
				<small>{Parser(stateToHTML(convertFromRaw(sanitizeDraftJsMap(disclaimer_json))))}</small>
			))}
		</React.Fragment>
	) : null
}

Disclaimer.propTypes = {
	advisor: PropTypes.object,
}

export default Disclaimer
